// extracted by mini-css-extract-plugin
export default {"referActionTile":"ReferActionTile-module__referActionTile-_Yow","spin":"ReferActionTile-module__spin-py7d","pulse":"ReferActionTile-module__pulse-fPxH"};